import React from "react";
import { interpolate } from "../interpolate";
import { useCurrentFrame } from "../use-current-frame";
import {AbsoluteFill} from "../AbsoluteFill"

export const Shrinking = ({ children }) => {
  const frame = useCurrentFrame();

  return (
    <AbsoluteFill
      style={{
        scale: String(
          interpolate(frame, [60, 90], [1, 0], {
            extrapolateLeft: "clamp",
            extrapolateRight: "clamp",
          })
        ),
      }}
    >
      {children}
    </AbsoluteFill>
  );
};